/**
 * New typescript file
 */
export class AppSettings {
  public static SERVICE_ENDPOINT = '';
  //  public static SERVICE_ENDPOINT = 'http://localhost:3000';
}


// WEBPACK FOOTER //
// ./src/app/AppSettings.ts